import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import 'jquery.easing/jquery.easing';
import "./dashboard.css";
import { NavLink } from "react-router-dom";
import { Sidebar } from '../sidebar/Sidebar';
import Navbar from '../navbar/navbar';
import _ from 'lodash';
import StarRatings from 'react-star-ratings';
import { getReviewByBusinessId,getReviews } from '../../../Services/reviews.service';
import { fs, fbStorage } from '../../../Services/firebase'
import { getBusiness } from '../../../Services/business.service';
//getBusiness 
export const BusinessDetails = (props) => {
  const [business, setBusiness] = useState(props.location.businessData);
  const [Reviews, setReviews] = useState();
  const [coverLogo,setcoverLogo] = useState('');
  const [foundReview,setfoundReview] = useState(false);
  console.log(props) 
  console.log('--------------', props.location.businessData);
  // const fireBaseData ={
  //   fireData:props.location.businessData
  // };
  
 const getData = async()=>{
   const day = await fs.collection('business').get();
   const data = await props.location.businessData;
   console.log(data.coverPhotoURL);
   setcoverLogo(data.coverPhotoURL);
   console.log('Day '+data);
 }
  useEffect(()=> {
   
    // setTimeout(getData,5000); props.location.businessData.businessId
    
    
    // getReviewByBusinessId(props.location.businessData.businessId).then((allreviews) => {
      //   console.log('all reviews of businss=====>', allreviews);
      //   setReviews(allreviews);
      // }, () => {
        
        // });

// Danish piece of code is start

    console.log('Data sended from the previous screen is ',props.location);
    getReviews().then((res)=>{
      console.log('Response of the reviews are : ',res);
      let myBusinessReviews =[];
      for(let i=0; i<res.length;i++)
      {
        // console.log('Review business id is ',res[i].itemId);
        // console.log('Orignal businesss ID is : ',props.location.businessData.businessId);
        if(res[i].itemId === props.location.businessData.businessId){
         let filterReview = {
         name:props.location.businessData.name,
         discription:res[i].discripton,
         status:false,
         rating:res[i].myRating 
        };
        myBusinessReviews.push(filterReview);
        console.log('Review about the buisiness is',filterReview);
        setfoundReview(true);
        }
      }
      setReviews(myBusinessReviews);
    })
   
   
    getData(); 
   
  
  }, []);

  return (
    <>
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            <div className="row">
              <div className="col">
                <h2 className="theme-color" style={{ marginLeft: 15 }}>Business Details</h2>
              </div>
            </div>
            {business ?
              <>
                <div className="row">
                  <div className="col-12">
                    <Table responsive striped bordered hover className="bg-white dashboardTable">
                      <thead>
                        <tr>
                          <th colSpan={2}><img className="driver-img rounded-circle" src={business.logoURL} /> {business.name}</th>
                        </tr>
                        <tr>
                          <th colSpan={2}>
                            {
                              coverLogo===''?<span>Loading the cover logo........</span>:
                            <img className="img-fluid coverLogo" src={coverLogo===''?'loading':coverLogo} alt="" />
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>

                          <th>Category</th>
                          <td>{business.categoryName}</td>
                        </tr>
                        <tr>
                          <th>City</th>
                          <td>{business.city}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{business.address}</td>
                        </tr>
                        <tr>
                          <th>Business Hours</th>
                          <td>Opened From {business.businessHours.map((answer, i) => {     
                         console.log("Entered");                 
                              // Return the element. Also pass key     
                            return (<span key={answer} answer={answer}>Day:{' '}{answer.days}{' '}{answer.from}{' '}To{' '}{answer.to}{''},</span>) 
                        })}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                {
                  <div className='row m-0 px-3'>
                    <div className='col-12 m-0 p-0'>
                       <h2>All reviews</h2>
                       <Table responsive striped bordered hover className="bg-white dashboardTable mt-2">
                       <thead>
                        <tr>
                          <th>Business Name</th>
                          <th>Review</th>
                          <th>Status</th>
                          <th>Ratings</th>
                          <th></th>
                        </tr>
                       </thead>
                       <tbody>
                        {/* Danish Work Start form here */}
                        {
                          foundReview?<>
                          {
                          Reviews&&Reviews.map((item,index)=>
                          <tr key={index}>
                              <td>Name</td>
                              <td>Business Tittle</td>
                              <td>Status</td>
                              <td>
                                <div className="w-mc">
                                  <StarRatings
                                    rating={2}
                                    starDimension="18px"
                                    starSpacing="1px"
                                    numberOfStars={5}
                                    starRatedColor="orange"
                                    style={{color:'yellow',backgroundColor:'yellow'}}
                                  />
                                </div>
                              </td>
                              <td className="actionButtonReview">
                                <div className="reviewActionDeleteButton buttonCommon">Delete</div>
                                <div className="buttonCommon btn-success reviewDetailActionButotn">
                                  <NavLink to={{
                                    pathname: "/admin/reveiw-detail",
                                    businessId: business.businessId
                                  }} className="color-white">Detail</NavLink>
                                </div>
                                
                              </td>

                          </tr>
                          )
                        }
                        </>:<>
                        <div className='w-100 p-2'>
                          <h1 className='text-center'>No Review found for this business</h1>
                        </div>
                        </>
                        }
                       {/* Danish Work Ends here */}
                       </tbody>
                       </Table>
                    </div>
                  </div>
                  
                 
                }
              </>: <></>
            }
          </div>
        </div>
      </div>
    </>
  )
}


